import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements AfterViewInit {

	@ViewChild('confirmButton') confirmButton!: ElementRef<HTMLButtonElement>;

	/**
	 * Default Constructor
	 * @param dialogRef 
	 * @param data 
	 */
	constructor(
		public dialogRef: MatDialogRef<ConfirmDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: {
			message: string;
			title?: string,
			confirmButton?: String,
			cancelButton?: string
		}
	) { }

	ngAfterViewInit(): void {
		// Wait for DOM to render
		setTimeout(() => {
			this.confirmButton?.nativeElement?.focus();
		});
	}
	onConfirm(): void {
		this.dialogRef.close(true);  // return true if confirmed
	}

	onCancel(): void {
		this.dialogRef.close(false); // return false if cancelled
	}
}